module.exports = __webpack_public_path__ + "media/images/ovalLogo-25ea355197df80a0874ec5f713b580d4.jpg";